module.exports = __webpack_public_path__ + "static/media/demo.5788cb27.png";